import _ from 'lodash';
import moment from 'moment';

const isJSON = (props) => {
  try {
    const obj = JSON.parse(props);
    return Boolean(obj) && typeof obj === 'object';
  } catch (e) {
    return false;
  }
};

const getTaskCompleteRemark = (tasksRemarksList, taskId) => {
  let remarkInfo = null;
  const currentTaskRemark = tasksRemarksList.find((subItem) => subItem.PARENT_ID === taskId) ?? null;
  if (currentTaskRemark) {
    const titleJson = isJSON(currentTaskRemark.TITLE) ? JSON.parse(currentTaskRemark.TITLE) : null;
    remarkInfo = {
      finishBy: titleJson?.finishBy ?? '',
      finishDate: titleJson?.finishDate ?? '',
      taskRemarkId: currentTaskRemark?.ID ?? '',
    };
  }

  return remarkInfo;
};

const getFieldList = (tasksList, type) => {
  return _.map(tasksList, (item) => ({
    isComplete: type === 'complete' ? 'Y' : 'N',
    title: item.TITLE,
    itemId: item.ID,
    sortIndex: item?.SORT_INDEX,
  }));
};

const getCompleteTaskApiParams = (tasksList, completeName) => {
  const unCompleteTasks = tasksList.filter((item) => item.IS_COMPLETE === 'N');
  const fieldList = getFieldList(unCompleteTasks, 'complete');

  const subItemList = _.map(unCompleteTasks, (item) => ({
    parentId: item.ID,
    title: JSON.stringify({
      finishBy: completeName,
      finishDate: moment().format('yyyy-MM-DD HH:mm:ss'),
    }),
  }));

  return {
    fieldList: fieldList,
    subItemList: subItemList,
    delSubItemList: null,
  };
};

const getUnCompleteTaskApiParams = (tasksList, taskRemarksList) => {
  let delCompleteRemarkIds = [];
  const alreadyCompleteTasks = tasksList.filter((item) => item.IS_COMPLETE === 'Y');
  const fieldList = getFieldList(alreadyCompleteTasks, 'unComplete');

  _.forEach(taskRemarksList, (remarkItem) => {
    if (_.some(alreadyCompleteTasks, (taskItem) => taskItem.ID === remarkItem.PARENT_ID)) {
      delCompleteRemarkIds.push(remarkItem.ID);
    }
  });

  return {
    fieldList: fieldList,
    subItemList: null,
    delSubItemList: delCompleteRemarkIds,
  };
};

const getRoleTypeColor = (role) => {
  switch (role.toLocaleUpperCase()) {
    case 'WARD IC':
      return '#f17a80';
    case 'NURSE':
      return '#ffc95c';
    case 'CLERK':
      return '#979bff';
    case 'SUPPORTING STAFF':
      return '#7adbef';
    default:
      return '#2e4469';
  }
};

const getRoomTypeFromApi = (individualUsers, roomTypesFromApi) => {
  if (!Array.isArray(individualUsers?.roomTypeList) || !Array.isArray(roomTypesFromApi)) {
    return [];
  }
  return _.filter(individualUsers?.roomTypeList, (roomItem) => roomTypesFromApi?.includes(roomItem?.value));
};

const getStaffFromApi = (individualUsers, staffFromApi) => {
  if (!Array.isArray(individualUsers?.staffList) || !Array.isArray(staffFromApi)) {
    return [];
  }
  return _.map(staffFromApi, (staffItem) => {
    if (_.some(individualUsers?.staffList, (item) => item?.corpId === staffItem?.corpId)) {
      return staffItem;
    } else {
      return {
        ...staffItem,
        type: 'OTHER',
      };
    }
  });
};

// ehandover的template如果是有checklist的时候,api返回来的title会加上'₩'符号,所以显示的时候要把title里面的符号删除
const removeChecklistTaskMark = (templateTitle) => {
  return templateTitle.replace(/₩/g, '');
};

const revampTemplateData = ({ templateItem, checkListGroup, individualUsers = [], initCheckListItem = null }) => {
  const initCheckLists = initCheckListItem ? [initCheckListItem] : [];
  const templateCheckList = checkListGroup?.[templateItem?.id] ?? initCheckLists;

  return {
    id: templateItem?.id ?? '',
    templateId: templateItem?.templateId ?? '',
    templateName: templateItem?.templateName ?? '',
    requiredAcknowLedge: templateItem?.mark === 'N',
    title: removeChecklistTaskMark(templateItem?.title ?? ''),
    description: templateItem?.description ?? '',
    checklistComplete: templateItem?.checklistComplete === 'Y',
    itemComplete: templateItem?.itemComplete === 'Y',
    notifyBaseOnSendTo: templateItem?.isBasedSendTo === 'Y',
    sendToList: {
      roomTypeList: getRoomTypeFromApi(individualUsers, templateItem?.sendToRoomType ?? []),
      staffList: getStaffFromApi(individualUsers, templateItem?.sendToCorp ?? []),
    },
    notifyList: {
      roomTypeList: getRoomTypeFromApi(individualUsers, templateItem?.checklistRoomTypeList ?? []),
      staffList: getStaffFromApi(individualUsers, templateItem?.checklistCorpList ?? []),
    },
    checkLists: _.map(templateCheckList, (checkItem) => ({
      isComplete: checkItem?.IS_COMPLETE === 'Y',
      parentId: checkItem?.PARENT_ID ?? '',
      sortIndex: checkItem?.SORT_INDEX ?? 0,
      title: checkItem?.TITLE ?? '',
    })),
    tags: Array.isArray(templateItem.tags) ? _.map(templateItem.tags, (item) => ({ ...item, id: item?.tagId })) : [],
  };
};

const getValBasedOnChecklistDisplay = (isShow, defaultVal, displayVal) => {
  return isShow ? displayVal : defaultVal;
};

const getSendToDisplayName = ({ individualUsers, sendToRoomType, sendToCorp }) => {
  if (_.isArray(sendToRoomType) && _.isArray(sendToCorp)) {
    const roomTypeList = _.filter(individualUsers?.roomTypeList, (roomType) =>
      sendToRoomType?.includes(roomType?.value)
    );
    const roomTypeDisplayName = _.map(roomTypeList, (item) => item?.name);
    const staffDisplayName = _.map(sendToCorp, (item) => item?.staffName);
    return [...roomTypeDisplayName, ...staffDisplayName].join(',');
  }
  return '';
};

const getInitCustomRecurrence = () => ({
  customRecurrence: false,
  intervalValue: '',
  intervalType: 'DAY',
  daysOfWeek: [],
  monthDayOfWeek: null, // 只有当monthRepeatType的类型是 NTH_DAY_OF_WEEK / LAST_DAY_OF_WEEK / SECOND_TO_LAST_DAY_OF_WEEK 才需要
  monthRepeatType: '',
  endDate: null,
});

export {
  isJSON,
  getTaskCompleteRemark,
  getCompleteTaskApiParams,
  getUnCompleteTaskApiParams,
  getRoleTypeColor,
  getRoomTypeFromApi,
  getStaffFromApi,
  revampTemplateData,
  getValBasedOnChecklistDisplay,
  getSendToDisplayName,
  getInitCustomRecurrence,
};
